export const Fields = {
    Company: {
        _id: 1,
        name: 1,
        name_nd: 1,
        accountingId: 1,
        accounting: 1,
        preferences: 1,
        analytics: 1,
        relation: 1,
        status: 1,
        picture: 1,
        public: 1,
        document: 1,
        organizationId: 1,
        merged: 1
    },
    // Comment: {
    //     accounting: 0,
    //     user: 0
    // },
    _Insight: {
        // companyId: 1,
        // ruleId: 1,
        // type: 1,
        // diagnosis: 1,
        // date: 1,
        // period: 1,
        // value: 1,
        // unit: 1,
        // target: 1,
        // limit: 1
        company: 0,
        kpi: 0,
        label: 0,
        period: 0,
        sources: 0,
        genus: 0,
        format: 0,
        accountingId: 0,
        description: 0,
        headline: 0,
        subtitle: 0
    },
    Insight: {
        "company._id": 0,
        "company.accounting": 0,
        "company.accountingId": 0,
        kpi: 0,
        label: 0,
        period: 0,
        genus: 0,
        format: 0,
        accountingId: 0
    },
    Serie: {
        updatedBy: 0,
        companyId: 0,
        accountingId: 0,
        isNormalized: 0,
        createdAt: 0,
        createdBy: 0,
        name_nd: 0,
        classifier_nz: 0
    },
    InsightRulesGroupd: {
        name: 1,
        _id: 1,
        position: 1,
        tooltip: 1,
        group: 1,
        unit: 1,
        dependency: 1,
        semiDependency: 1,
        visualizationId: 1,
        rows: 1,
        insights: 1,
        series: 1,
        status: 1,
        companyId: 1,
        referenceId: 1,
        type: 1,
        formula: 1,
        complexCondition: 1,
        variationCondition: 1,
        sources: 1
    }
};
